import axios from "axios";

// fundswalla.in/Api sends no Access-Control-Allow-Origin, so in dev we go through
// the setupProxy.js same-origin route instead of calling the host directly.
const CHECK_CUSTOMER_BY_PAN_URL =
  process.env.NODE_ENV === "development"
    ? "/Api/TaskApi/checkGetCustomerbyPan"
    : "https://fundswalla.in/Api/TaskApi/checkGetCustomerbyPan";

/** Loan statuses where customer may submit a fresh application */
const REAPPLY_ALLOWED_STATUSES = new Set(["REJECT", "CLOSED", ""]);

/**
 * Check existing customer / loan status by PAN (fundswalla.in TaskApi).
 * Returns blocked:true when customer cannot re-apply.
 */
export const checkCustomerByPan = async (pan) => {
  const pancard = String(pan || "").trim().toUpperCase();

  if (pancard.length !== 10) {
    return { blocked: false };
  }

  try {
    const res = await axios.get(CHECK_CUSTOMER_BY_PAN_URL, {
      params: { pancard },
      timeout: 20000,
    });

    const payload = res.data;

    if (payload?.status === true && payload?.data) {
      const loanStatus = String(payload.data.status || "")
        .trim()
        .toUpperCase();

      if (loanStatus && !REAPPLY_ALLOWED_STATUSES.has(loanStatus)) {
        return {
          blocked: true,
          message: `Your loan status is ${loanStatus}. Cannot re-apply.`,
          loanStatus,
          customerData: payload.data,
        };
      }
    }

    return { blocked: false, customerData: payload?.data || null };
  } catch (err) {
    if (err?.response?.status === 404) {
      return { blocked: false };
    }

    return { blocked: false, checkFailed: true };
  }
};
